import writeExcelFile, { Cell, SheetData } from "write-excel-file/browser";

const SHEET_NAME = "Datos";

// write-excel-file solo acepta string, number, boolean, Date o null por celda
const toCell = (value: unknown): Cell => {
    if (value === null || value === undefined) return null;
    if (typeof value === "number") return Number.isFinite(value) ? value : String(value);
    if (typeof value === "string" || typeof value === "boolean" || value instanceof Date) return value;
    return String(value);
};

const toSheetData = (rows: unknown[][]): SheetData =>
    rows.map((row) => row.map(toCell));

export const createExcel = (rows: unknown[][]) =>
    writeExcelFile(toSheetData(rows), { sheet: SHEET_NAME });